export default {
  nav_home: 'Home',
  nav_guides: 'Guides',
  nav_categories: 'Categories',
  nav_shopping_guide: 'Shopping Guide',
  nav_safety: 'Safety',
  nav_faq: 'FAQ',
  nav_about: 'About',
  hero_eyebrow: 'CSSBuy Spreadsheet • Guides • Products • Tips',
  hero_h1: 'CSSBuy Spreadsheet — Find Products, Sellers & Guides in One Place',
  hero_desc: 'Find and organize useful CSSBuy resources with ease. Explore CSSBuy spreadsheets, products, sellers, QC guides, shipping information, warehouse, coupons and practical tips to research better and make more informed decisions.',
  hero_cta_primary: 'Explore CSSBuy Spreadsheet',
  hero_cta_secondary: 'View CSSBuy Guides',
  hero_search_placeholder: 'Search for product, category or CSSBuy Spreadsheet...',
  trust_recursos: 'Organized Resources',
  trust_atualizado: 'Updated Content',
  trust_guides: 'Practical Guides',
  trust_seguranca: 'Safety Focus',
  categories_h2: 'Product Categories',
  categories_desc: 'Browse the most popular categories and find what you are looking for.',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  cta_buy_it_now: 'Buy It Now',
  cta_visit_main: 'Visit Main Website',
  articles_h2: 'CSSBuy Guides & Articles',
  articles_desc: 'Read our complete guides to make more informed decisions.',
  article_read_guide: 'Read Guide',
  footer_resources: 'Resources',
  footer_categories: 'Categories',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_disclaimer: 'Disclaimer',
  footer_disclaimer_text: 'This is an independent information and resources website. We are not officially affiliated with, sponsored by, or endorsed by CSSBuy unless expressly stated.',
  footer_copyright: '© 2026 cssbuybr.living — All rights reserved.',
  review_h2: 'CSSBuy Review: What You Need to Know Before Buying',
  review_desc: 'Understand how products, sellers, warehouse, quality control and shipping work before making a decision. Our CSSBuy Review guide gathers practical information to help you evaluate the service more informed.',
  review_cta: 'Read CSSBuy Review',
  shipping_h2: 'CSSBuy Shipping Cost: Understand Shipping Costs',
  shipping_desc: 'Shipping costs may vary depending on weight, volume, destination and chosen method. Check our guide to understand the main factors that influence the price before finalizing your purchase.',
  shipping_cta: 'View CSSBuy Shipping Cost',
  coupon_h2: 'CSSBuy Coupon & Discount Code',
  coupon_desc: 'Check our CSSBuy Coupon and CSSBuy Discount Code guide to understand where to look for promotions, how to check conditions and how to avoid outdated or suspicious codes.',
  coupon_cta: 'View Coupons & Discounts',
  how_it_works_h2: 'How to Use a CSSBuy Spreadsheet',
  how_step_1: 'Choose a category',
  how_step_2: 'Find a product or resource',
  how_step_3: 'Check seller and information',
  how_step_4: 'Check QC when available',
  how_step_5: 'Analyze shipping and costs',
  how_step_6: 'Make your decision',
  how_cta: 'Start with CSSBuy Spreadsheet',
  comparison_h2: 'CSSBuy Spreadsheet vs. Manual Search',
  comparison_criterio: 'Criteria',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_manual: 'Manual Search',
  comparison_organizacao: 'Organization',
  comparison_alta: 'High',
  comparison_variavel: 'Variable',
  comparison_descoberta: 'Discovery',
  comparison_simples: 'Simpler',
  comparison_demorada: 'More time-consuming',
  comparison_categorias: 'Categories',
  comparison_estruturadas: 'Structured',
  comparison_dispersas: 'Dispersed',
  comparison_pesquisa: 'Research',
  comparison_centralizada: 'Centralized',
  comparison_diversas: 'Multiple sources',
  comparison_guias: 'Guides',
  comparison_integrados: 'Integrated',
  comparison_separados: 'Separate',
  final_cta_h2: 'Find Your Next CSSBuy Spreadsheet',
  final_cta_desc: 'Explore categories, guides, comparisons, shipping information, QC and resources to make your research simpler.',
  final_cta_primary: 'Explore CSSBuy Spreadsheet',
  final_cta_secondary: 'Visit Main Website',
  breadcrumb_home: 'Home',
  article_updated: 'Updated',
  article_reading_time: 'min read',
  related_articles: 'Related Articles',
  toc_title: 'Contents',
  safety_note: 'Safety Note',
  safety_note_text: 'When buying internationally, safety should come before speed. Learn how to check links, products, sellers, payments, QC and shipping information before making a decision.',
};